module.exports = __webpack_public_path__ + "img/reset_device.acd14c6a.gif";